<template>
  <div>
    <b-container v-if="companyId">
      <b-row>
        <b-col lg="6" sm="12">
          <h3 class="text-left mt-2 mb-2">Cég hozzáadása</h3>

          <b-row>
            <b-col class="registration-offer-holder mt-4 mb-4 ml-3 mr-3">
              <h4>Már csak egy lépés van hátra a regisztráció befejezéséig!</h4>
              <p class="mt-4">
                Az Ön által kiválasztott és képviselt céget összekötjük a profiljával, <br />
                így a későbbiekben is tájékozódhat az aktuális fejlesztési lehetőségekről..
              </p>
            </b-col>
          </b-row>

          <div class="mt-2 text-left">
            <b-row>
              <b-col>
                <b-form>
                  <h4 v-if="selectedCompany">{{ selectedCompany.long_name[0].name }}</h4>
                  <b-form-select v-model="selectedPosition" :options="positionOptions" class="mt-3"></b-form-select>
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="statement"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    class="mt-3"
                  >
                    Elfogadom a
                    <a download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
                      Felhasználási feltételeket
                    </a>
                  </b-form-checkbox>
                  <b-button
                    class="mt-4"
                    type="submit"
                    variant="primary"
                    @click.prevent="onConfirmationSubmission"
                    :disabled="isLoading"
                  >
                    <b-spinner small v-if="isLoading"></b-spinner>
                    <span class="sr-only" v-if="isLoading">Betöltés...</span>
                    <span v-if="!isLoading">Hozzáadás</span>
                  </b-button>
                </b-form>
                <br />
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col lg="6" class="d-none d-lg-block p-5">
          <add-company-svg></add-company-svg>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="soleProprietorshipId">
      <b-row>
        <b-col lg="6" sm="12">
          <h3 class="text-left mt-2 mb-2">Egyéni vállalkozás hozzáadása</h3>

          <b-row>
            <b-col class="registration-offer-holder mt-4 mb-4 ml-3 mr-3">
              <h4>Már csak egy lépés van hátra a regisztráció befejezéséig!</h4>
              <p class="mt-4">
                Az Ön által kiválasztott és képviselt egyéni vállalkozást összekötjük a profiljával, <br />
                így a későbbiekben is tájékozódhat az aktuális fejlesztési lehetőségekről..
              </p>
            </b-col>
          </b-row>

          <div class="mt-2 text-left">
            <b-row>
              <b-col>
                <b-form>
                  <h4 v-if="selectedCompany">{{ selectedCompany.name }}</h4>
                  <b-form-select
                    v-model="selectedPosition"
                    :options="soleProprietorshipPositionOptions"
                    class="mt-3"
                  ></b-form-select>
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="statement"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    class="mt-3"
                  >
                    Elfogadom a
                    <a download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
                      Felhasználási feltételeket
                    </a>
                  </b-form-checkbox>
                  <b-button
                    class="mt-4"
                    type="submit"
                    variant="primary"
                    @click.prevent="onConfirmationSubmission"
                    :disabled="isLoading"
                  >
                    <b-spinner small v-if="isLoading"></b-spinner>
                    <span class="sr-only" v-if="isLoading">Betöltés...</span>
                    <span v-if="!isLoading">Hozzáadás</span>
                  </b-button>
                </b-form>
                <br />
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col lg="6" class="d-none d-lg-block p-5">
          <add-company-svg></add-company-svg>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AddCompanySvg from '@/components/svg/AddCompany/AddCompany.vue'
import queryString from 'query-string'
import { mapGetters } from 'vuex'
import * as FundMapApi from '../api/fundMap'

export default {
  components: {
    AddCompanySvg
  },
  data() {
    return {
      selectedPosition: null,
      positionOptions: [
        { value: null, text: 'cégben betöltött tisztség' },
        { value: 'OWNER', text: 'Tulajdonos' },
        { value: 'SENIOR_OFFICER', text: 'Vezető tisztségviselő' },
        { value: 'ACCOUNTANT', text: 'Könyvelő' },
        { value: 'APPLICATION_WRITER', text: 'Pályázatíró' },
        { value: 'CONSULTANT', text: 'Tanácsadó' }
      ],
      soleProprietorshipPositionOptions: [
        { value: null, text: 'egyéni vállalkozásban betöltött tisztség' },
        { value: 'SOLE_PROPRIETORSHIP', text: 'Vállalkozó' },
        { value: 'ACCOUNTANT', text: 'Könyvelő' },
        { value: 'APPLICATION_WRITER', text: 'Pályázatíró' },
        { value: 'CONSULTANT', text: 'Tanácsadó' }
      ],
      companyId: 0,
      soleProprietorshipId: 0,
      userId: 0,
      token: '',
      statement: 'not_accepted'
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'selectedCompany'])
  },
  methods: {
    async onConfirmationSubmission() {
      const params = queryString.parse(location.search)
      const { redir } = params

      if (this.statement == 'not_accepted') {
        this.$store.dispatch('notify', {
          newNotification: { type: 'info', message: 'A felhasználási feltételek elfogadása kötelező.' }
        })
      } else {
        if (this.selectedPosition) {
          const confirmData = {
            registrationConfirmationToken: this.token,
            companyId: this.companyId,
            position: this.selectedPosition,
            userId: this.userId,
            soleProprietorshipId: this.soleProprietorshipId
          }
          await this.$store.dispatch('confirmRegistration', confirmData)
          await this.$store.dispatch('getMe')
          if (this.companyId) {
            if (redir) {
              this.$router.push(`/${redir}?companyId=${this.companyId}`)
            }
            this.$router.push('/company-offers-private')
          }
          if (this.soleProprietorshipId) {
            if (redir) {
              this.$router.push(`/${redir}?soleProprietorshipId=${this.soleProprietorshipId}`)
            }
            this.$router.push('/sole-proprietorship-offers-private')
          }
        } else {
          this.$store.dispatch('notify', {
            newNotification: { type: 'info', message: 'A cégben betöltött tisztség kiválasztása kötelező.' }
          })
        }
      }
    },
    addCompanyAttribute(key, value) {
      this.$store.dispatch('setCompanyAttributeAction', { [key]: value })
    },
    addCompany(key, value) {
      this.$store.dispatch('setFundMapCompanyAction', { [key]: value })
    }
  },
  async created() {
    const params = queryString.parse(location.search)
    const { token, companyId, soleProprietorshipId, sessionId } = params

    this.token = token
    this.companyId = companyId
    this.soleProprietorshipId = soleProprietorshipId
    if (!token) {
      this.$router.push('/login')
    } else {
      try {
        let confirmationData = {
          registrationConfirmationToken: token
        }
        if (this.companyId !== undefined) {
          confirmationData = {
            ...confirmationData,
            companyId
          }
        } else if (this.soleProprietorshipId !== undefined) {
          confirmationData = {
            ...confirmationData,
            soleProprietorshipId
          }
        }
        const id = await this.$store.dispatch('validateConfirmationData', confirmationData)
        this.userId = id

        if (this.companyId === undefined && this.soleProprietorshipId === undefined) {
          const confirmData = {
            registrationConfirmationToken: this.token,
            userId: this.userId
          }
          await this.$store.dispatch('confirmRegistration', confirmData)
          await this.$store.dispatch('getMe')
          if (sessionId) {
            const fundMapData = await FundMapApi.getFundmapDataFromCacheService(sessionId)

            if (fundMapData.isImaginaryCompany == true) {
              const imaginaryCompany = {
                form: fundMapData.form,
                name: fundMapData.name,
                mainTeaor: fundMapData.mainTeaor,
                secondaryTeaors: fundMapData.secondaryTeaors,
                address: fundMapData.address,
                sites: fundMapData.sites,
                income: fundMapData.income,
                balanceSheetTotal: fundMapData.balanceSheetTotal,
                headCount: fundMapData.headCount
              }
              this.addCompany('imaginaryCompany', imaginaryCompany)
              return await this.$router.push(`/fund-map/create-company`)
            }

            if (fundMapData.attributes.teaor) {
              this.addCompanyAttribute('teaor', fundMapData.attributes.teaor)
            }
            if (fundMapData.attributes.zip) {
              this.addCompanyAttribute('zip', fundMapData.attributes.zip)
            }
            if (fundMapData.attributes.address) {
              this.addCompanyAttribute('address', fundMapData.attributes.address)
            }
            if (fundMapData.attributes.isSupplier) {
              this.addCompanyAttribute('isSupplier', fundMapData.attributes.isSupplier)
            }
            if (fundMapData.attributes.revenueFromAggriculture) {
              this.addCompanyAttribute('revenueFromAggriculture', fundMapData.attributes.revenueFromAggriculture)
            }

            const getCompanyQueryParams = { value: fundMapData.company.flaggerId }
            await this.$store.dispatch('getFundMapCompanyAction', getCompanyQueryParams)

            this.$store.dispatch('selectFundMapCategoryAction', fundMapData.category)
            this.$store.dispatch('nextStepAction')

            return await this.$router.push(`/fund-map/search`)
          }
          this.$router.push('/home?reg_ok=1')
        } else {
          if (this.companyId !== undefined) {
            const getCompanyQueryParams = { value: this.companyId }
            await this.$store.dispatch('getCompany', getCompanyQueryParams)
          }
          if (this.soleProprietorshipId !== undefined) {
            const getSoleProprietorshipQueryParams = { value: this.soleProprietorshipId }
            await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
          }
        }
      } catch (err) {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.registration-offer-holder {
  background-color: #00903c;
  padding: 30px;
  border-radius: 10px;
  color: white !important;
}

.registration-offer-holder h4 {
  color: white;
  font-weight: bold;
}
</style>
